import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { HistoryItem } from '../../types/terminal'
import { executeCommand } from '../../utils/commandExecutor'
import { TerminalHeader } from './TerminalHeader'
import { TerminalBody } from './TerminalBody'
import styles from './Terminal.module.css'

const INITIAL_HISTORY: HistoryItem[] = [
  { type: 'output', content: 'Welcome to sroy.co.uk' },
  { type: 'output', content: 'Type "help" for available commands.' },
  { type: 'output', content: '' },
]

export function Terminal() {
  const navigate = useNavigate()
  const [history, setHistory] = useState<HistoryItem[]>(INITIAL_HISTORY)
  const [input, setInput] = useState('')
  const [commandHistory, setCommandHistory] = useState<string[]>([])
  const [historyIndex, setHistoryIndex] = useState(-1)

  const handleCommand = (cmd: string) => {
    const trimmedCmd = cmd.trim().toLowerCase()
    
    // Handle special navigation commands
    if (trimmedCmd === 'event') {
      setHistory(prev => [
        ...prev,
        { type: 'input', content: `$ ${cmd}` },
        { type: 'output', content: 'Navigating to event page...' },
      ])
      setTimeout(() => {
        navigate('/event')
      }, 500)
      return
    }

    if (trimmedCmd === 'cv') {
      setHistory(prev => [
        ...prev,
        { type: 'input', content: `$ ${cmd}` },
        { type: 'output', content: 'Navigating to CV page...' },
      ])
      setTimeout(() => {
        navigate('/cv')
      }, 500)
      return
    }
    
    executeCommand(cmd, setHistory)
    
    if (trimmedCmd && !commandHistory.includes(trimmedCmd)) {
      setCommandHistory(prev => [...prev, trimmedCmd])
    }
  }

  return (
    <div className={styles.container}>
      <TerminalHeader />
      <TerminalBody
        history={history}
        input={input}
        setInput={setInput}
        commandHistory={commandHistory}
        historyIndex={historyIndex}
        setHistoryIndex={setHistoryIndex}
        onCommand={handleCommand}
      />
    </div>
  )
}

